import { FlaskConical } from "lucide-react";
import { MARQUEE_ITEMS } from "../data/site";

export const Marquee = () => {
  const seq = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  const Row = () => (
    <div className="flex shrink-0 items-center" aria-hidden="true">
      {seq.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-[13px] sm:text-base tracking-wide text-offwhite whitespace-nowrap px-4 sm:px-6">
            {item}
          </span>
          <FlaskConical className="h-4 w-4 text-charcoal shrink-0" strokeWidth={2.5} />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="marquee-strip"
      className="relative w-full overflow-hidden bg-labred py-3 border-y-2 border-charcoal"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  );
};
